import { useTranslation } from "@next-platform/client-common-core";
import getMediaFileDisplay from "@next-platform/client-common-core/viewMedia/common/getMediaFileDisplay";
import { MediaFileUnavailable, Size } from "@next-platform/client-common-spicy-ui";
import { memo } from "react";

import MediaFilePreviewContent from "./MediaFilePreviewContent";
import type { MediaFilePreviewProps } from "./types";

export const MEDIA_FILE_PREVIEW_TEST_ID = "MediaFilePreview";

const MediaFilePreview = ({ file, isBlurred, "data-testid": testId = MEDIA_FILE_PREVIEW_TEST_ID, onOpen }: MediaFilePreviewProps) => {
  const { t } = useTranslation();
  const display = getMediaFileDisplay({ file, translate: t });

  if (display.placeholder) {
    return (
      <article data-testid={testId} className="relative overflow-hidden rounded-2xl bg-gray-3 text-gray-12 [container-type:inline-size]">
        <div aria-hidden="true" className="aspect-[4/5] w-full" />
        <div aria-hidden="true" className="h-11 tile-lg:h-[60px]" />
        <MediaFileUnavailable
          placeholder={display.placeholder}
          size={Size.SMALL}
          className="absolute inset-0"
          data-testid={`${testId}-Unavailable`}
        />
      </article>
    );
  }

  return <MediaFilePreviewContent file={display.file} isBlurred={isBlurred} onOpen={onOpen} data-testid={testId} />;
};

export default memo(MediaFilePreview);
